<div [ngStyle]="{'width.px': width, 'height.px': height, '--loader-color': 'var(--loader-color)'}">
  <ng-lottie [options]="options" [styles]="{ width: '100%', height: '100%' }"></ng-lottie>
</div>
